import http from 'hub-http/clients/apiClient';
export function bulkDeleteHard(ids) {
  return http.delete('cosemail/v1/emails/delete-hard/bulk', {
    query: {
      id: ids,
      failIfNotAllSucceed: true
    }
  });
}
export function bulkDelete(ids) {
  return http.delete('cosemail/v1/emails/bulk', {
    query: {
      id: ids,
      failIfNotAllSucceed: true
    }
  });
}